import {
  ADD_EMPLOYEE_FAIL,
  ADD_EMPLOYEE_REQUEST,
  ADD_EMPLOYEE_SUCCESS,
  CREATE_ADMIN_GEOFENCE_FAIL,
  CREATE_ADMIN_GEOFENCE_REQUEST,
  CREATE_ADMIN_GEOFENCE_SUCCESS,
  DELETE_ADMIN_GEOFENCE_FAIL,
  DELETE_ADMIN_GEOFENCE_REQUEST,
  DELETE_ADMIN_GEOFENCE_SUCCESS,
  GET_ADMIN_GEOFENCE_LIST_FAIL,
  GET_ADMIN_GEOFENCE_LIST_REQUEST,
  GET_ADMIN_GEOFENCE_LIST_SUCCESS,
} from "../../types/admin/geoFenceTypes";

export const createAdminGeoFenceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_ADMIN_GEOFENCE_REQUEST:
      return {
        ...state,
        createAdminGeoFenceLoading: true,
      };
    case CREATE_ADMIN_GEOFENCE_SUCCESS:
      return {
        ...state,
        createAdminGeoFenceLoading: false,
        createAdminGeoFenceInfo: payload,
        createAdminGeoFenceError: "",
      };
    case CREATE_ADMIN_GEOFENCE_FAIL:
      return {
        ...state,
        createAdminGeoFenceLoading: false,
        createAdminGeoFenceInfo: [],
        createAdminGeoFenceError: payload,
      };
    default:
      return state;
  }
};

export const getAdminGeoFenceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ADMIN_GEOFENCE_LIST_REQUEST:
      return {
        ...state,
        getAdminGeoFenceLoading: true,
      };
    case GET_ADMIN_GEOFENCE_LIST_SUCCESS:
      return {
        ...state,
        getAdminGeoFenceLoading: false,
        getAdminGeoFenceInfo: payload,
        getAdminGeoFenceError: "",
      };
    case GET_ADMIN_GEOFENCE_LIST_FAIL:
      return {
        ...state,
        getAdminGeoFenceLoading: false,
        getAdminGeoFenceInfo: [],
        getAdminGeoFenceError: payload,
      };
    default:
      return state;
  }
};

export const deleteAdminGeoFenceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_ADMIN_GEOFENCE_REQUEST:
      return {
        ...state,
        deleteAdminGeoFenceLoading: true,
      };
    case DELETE_ADMIN_GEOFENCE_SUCCESS:
      return {
        ...state,
        deleteAdminGeoFenceLoading: false,
        deleteAdminGeoFenceInfo: payload,
        deleteAdminGeoFenceError: "",
      };
    case DELETE_ADMIN_GEOFENCE_FAIL:
      return {
        ...state,
        deleteAdminGeoFenceLoading: false,
        deleteAdminGeoFenceInfo: [],
        deleteAdminGeoFenceError: payload,
      };
    default:
      return state;
  }
};

export const addEmpAdminGeoFenceReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ADD_EMPLOYEE_REQUEST:
      return {
        ...state,
        addEmpAdminGeoFenceLoading: true,
      };
    case ADD_EMPLOYEE_SUCCESS:
      return {
        ...state,
        addEmpAdminGeoFenceLoading: false,
        addEmpAdminGeoFenceInfo: payload,
        addEmpAdminGeoFenceError: "",
      };
    case ADD_EMPLOYEE_FAIL:
      return {
        ...state,
        addEmpAdminGeoFenceLoading: false,
        addEmpAdminGeoFenceInfo: [],
        addEmpAdminGeoFenceError: payload,
      };
    default:
      return state;
  }
};
